module.exports = __webpack_public_path__ + "img/1_3.c9e76a0e.gif";